import React from 'react';
import { Link } from 'react-router-dom';

import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

import ExternalHtml from '@common/react/components/UI/ExternalHtml/ExternalHtml';
import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import { Page } from '@commonTuna/react/objects/Page';

interface Props {
	items: Array<Page>;
}

const ServicesBlock: React.FC<Props> = ({ items }) => {
	const pagination = {
		clickable: true,
	};

	return (
		<>
			<Swiper
				pagination={pagination}
				modules={[Pagination]}
				className="mySwiper"
				autoHeight
				observer
				observeParents
				observeSlideChildren
			>
				{items.map((item) => <SwiperSlide key={item.id}>
					<ImageLazy alt={item.name} width="400px" height="400px" className="slider-image" src={`/remote/${item.originalAvatar}`} />
					<div className="slider-text">
						{item.shortNameEn && <h3 className="slider-name">
							{item.fullPath ? <Link to={`/${item.fullPath}`}>
								{item.shortNameEn}
							</Link> : item.shortNameEn}
						</h3>}
						{item.langs && item.langs.length > 0 && item.langs[0].shortBody
							? <ExternalHtml html={item.langs[0].shortBody} />
							: ''
						}
					</div>
				</SwiperSlide>)}
			</Swiper>
		</>
	);
};

export default ServicesBlock;
